import { BookingRulesType } from '../api/types/response/booking-rule.response';

export const bookingRulesTypeTranslations = {
  [BookingRulesType.HOURLY]: 'common.hourlyBooking',
  [BookingRulesType.DAILY]: 'common.dailyBooking',
} as const;
